import type { HistoricalDataDto } from '../../types/dto/HistoricalDataDto';
import type { HistoricalData } from '../../types/HistoricalData';
import type { AxiosResponse } from 'axios';

const sortHistoricalDataByDate = <T extends { month: number; year: number }>(data: T[]) =>
  [...data].sort((a, b) => {
    if (a.year > b.year) return -1;
    if (a.year < b.year) return 1;

    if (a.month > b.month) return -1;
    if (a.month < b.month) return 1;

    return 0;
  });

export const mapAllHistoricalDataDtoToHistoricalData = ({
  data
}: AxiosResponse<HistoricalDataDto[]>): HistoricalData[] => {
  const historicalData = sortHistoricalDataByDate(data);
  return historicalData.map(record => {
    const {
      year,
      month,
      butterfatTest,
      proteinTest,
      milkProduction,
      milkPrice,
      productionCost,
      projected
    } = record;
    return {
      year,
      month,
      butterfatTest,
      proteinTest,
      milkProduction,
      milkPrice,
      productionCost,
      projected,
      isEditing: false,
      isNew: false
    };
  });
};
